import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const manageJourneysDialogStyle: SxProps<Theme> = {
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: YodaBorderRadius.medium,
  },
};

export const headerCellStyles: SxProps<Theme> = {
  fontWeight: YodaFontWeight.medium,
  fontSize: YodaFontSize.small,
  borderBottom: 'none',
};

export const tableStyles: SxProps<Theme> = {
  borderCollapse: 'separate',
  borderSpacing: '0 8px',
};

export const tableRowStyles: SxProps<Theme> = {
  boxShadow: `inset 0 0 0 1px ${YodaColors.gray2}, 0px 2px 4px rgba(87, 102, 126, 0.08)`,
  borderRadius: YodaBorderRadius.small,
  height: '56px',
  fontWeight: YodaFontWeight.light,
  fontSize: YodaFontSize.small,
  transition: 'box-shadow .2s ease-out, background-color .2s ease-out',
  '&:hover': {
    backgroundColor: YodaColors.primaryLighter,
    boxShadow: `inset 0 0 0 1px ${YodaColors.gray2}, 0 2px 10px 0 rgba(18, 32, 53, 0.1)`,
  },
  '& .MuiTableCell-root': {
    borderBottom: 'none',
    paddingY: fromUnitsToRem(YodaSpacing.small),
    fontSize: YodaFontSize.small,
    color: YodaColors.textPrimary,
  },
};

export const journeyNameStyles: SxProps<Theme> = {
  fontWeight: YodaFontWeight.medium,
};

export const statusBadgeStyles = (isActive: boolean): SxProps<Theme> => ({
  display: 'inline-block',
  padding: '4px 12px',
  borderRadius: '16px',
  fontSize: YodaFontSize.small,
  fontWeight: YodaFontWeight.medium,
  backgroundColor: isActive ? YodaColors.greenSuccessLight : YodaColors.gray2,
  color: isActive ? YodaColors.greenSuccessDark : YodaColors.gray4,
});

export const noJourneysStyles: SxProps<Theme> = {
  color: YodaColors.gray4,
};
